import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Collapse, useCollapseUnique } from '.';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "collapse"
    }}>{`Collapse`}</h1>
    <p>{`Is an alternative to the `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/details"
      }}><inlineCode parentName="a">{`<details>`}</inlineCode></a>{` element. Can be used as an accordion, where only one item can be expanded at a time.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { Collapse as AtlanticCollapse, useCollapseUnique } from '@atlasgroup/react-atlantic';

// also, that's kinda bs, pls fix
const Collapse = wrap(AtlanticCollapse, useCollapseUnique);
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><inlineCode parentName="p">{`Collapse`}</inlineCode>{` must be wrapped with `}<inlineCode parentName="p">{`useCollapseUnique`}</inlineCode>{` to make the element interactive. Using the component with a custom hook is encouraged.`}</p>
    </blockquote>
    <Playground __position={0} __code={'<Collapse activeUnique=\"1\">\n  <Collapse.Panel header={<strong>Expanded</strong>} unique=\"1\">\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ultricies,\n    lorem sed ultrices sagittis, nisi orci aliquam tortor, eget facilisis nunc\n    eros eu nisl.\n  </Collapse.Panel>\n  <Collapse.Panel header={<strong>Hidden</strong>} unique=\"2\">\n    Lorem ipsum dolor sit amet.\n  </Collapse.Panel>\n  <Collapse.Panel header={<strong>Hidden</strong>} unique=\"3\">\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget ex eu\n    nisi aliquam sagittis.\n  </Collapse.Panel>\n</Collapse>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Collapse,
      useCollapseUnique,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Collapse activeUnique="1" mdxType="Collapse">
        <Collapse.Panel header={<strong>Expanded</strong>} unique="1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ultricies, lorem sed ultrices sagittis, nisi
            orci aliquam tortor, eget facilisis nunc eros eu nisl.
        </Collapse.Panel>
        <Collapse.Panel header={<strong>Hidden</strong>} unique="2">
            Lorem ipsum dolor sit amet.
        </Collapse.Panel>
        <Collapse.Panel header={<strong>Hidden</strong>} unique="3">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eget ex eu nisi aliquam sagittis.
        </Collapse.Panel>
    </Collapse>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      